import React, { useState, useEffect } from 'react';
import { Check, X, AlertCircle, Info } from 'lucide-react';

const Toast = ({ message, type = 'success', onClose, duration = 4000 }) => {
  const [progress, setProgress] = useState(100);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const interval = 10;
    const decrement = (100 * interval) / duration;

    const progressTimer = setInterval(() => {
      setProgress((prev) => {
        if (prev <= 0) {
          clearInterval(progressTimer);
          return 0;
        }
        return prev - decrement;
      });
    }, interval);

    const closeTimer = setTimeout(() => {
      setIsClosing(true);
      setTimeout(onClose, 300);
    }, duration);

    return () => {
      clearInterval(progressTimer);
      clearTimeout(closeTimer);
    };
  }, [duration, onClose]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(onClose, 300);
  };

  const config = {
    success: {
      icon: Check,
      iconBg: 'bg-emerald-50',
      iconColor: 'text-emerald-600',
      progressColor: 'bg-emerald-500'
    },
    error: {
      icon: X,
      iconBg: 'bg-red-50',
      iconColor: 'text-red-600',
      progressColor: 'bg-red-500'
    },
    warning: {
      icon: AlertCircle,
      iconBg: 'bg-amber-50',
      iconColor: 'text-amber-600',
      progressColor: 'bg-amber-500'
    },
    info: {
      icon: Info,
      iconBg: 'bg-blue-50',
      iconColor: 'text-blue-600',
      progressColor: 'bg-blue-500'
    }
  };

  const currentConfig = config[type] || config.success;
  const Icon = currentConfig.icon;

  return (
    <div className={`${isClosing ? 'animate-slide-out-right' : 'animate-slide-in-right'}`}>
      <div className="bg-white border border-ink-100 rounded-xl shadow-lifted overflow-hidden min-w-[320px] max-w-md">
        <div className="px-4 py-3 flex items-center gap-3">
          <div className={`w-8 h-8 ${currentConfig.iconBg} rounded-full flex items-center justify-center flex-shrink-0`}>
            <Icon size={16} className={currentConfig.iconColor} />
          </div>
          <p className="text-sm text-ink-700 flex-1 leading-relaxed">{message}</p>
          <button
            onClick={handleClose}
            className="text-ink-300 hover:text-ink-500 transition-colors p-1 flex-shrink-0"
          >
            <X size={16} />
          </button>
        </div>
        <div className="h-0.5 bg-ink-50">
          <div
            className={`h-full ${currentConfig.progressColor} transition-all duration-100 ease-linear`}
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default Toast;
